module.exports = __webpack_public_path__ + "static/media/visitor_manager.6fcb545c.svg";